module.exports = __webpack_public_path__ + "img/delivery-small.22425a78.svg";